export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "app/js/app.worker.6d891a8564648741e120.1781007443297.worker.js");
}
